
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

export const db = firebase.firestore;
export const auth = firebase.auth;
export const storage = firebase.storage;
export const functions = firebase.functions;

const env = process.env.REACT_APP_ENV;


const firebaseProdConfig = {
    apiKey: "AIzaSyBu6R1zXT4OKWunsBS-0MY7woiiARbgqQA",
    authDomain: "operataxis.firebaseapp.com",
    projectId: "operataxis",
    storageBucket: "operataxis.firebasestorage.app",
    messagingSenderId: "784489366927",
    appId: "1:784489366927:web:06c0b1d63beba63e9377fa",
    measurementId: "G-TPWK71TL9L"
};

const firebaseDevConfig = {
    apiKey: "AIzaSyBu6R1zXT4OKWunsBS-0MY7woiiARbgqQA",
  authDomain: "operataxis.firebaseapp.com",
  projectId: "operataxis",
  storageBucket: "operataxis.firebasestorage.app",
  messagingSenderId: "784489366927",
  appId: "1:784489366927:web:06c0b1d63beba63e9377fa",
  measurementId: "G-TPWK71TL9L"
  };

//initialize firebase with above config
const projectConfig = env === "dev" ? firebaseDevConfig : firebaseProdConfig;
//initialize firebase with above config
firebase.initializeApp(projectConfig);


/****************** firestore refs ******************/

const users = db().collection('users');
const usersData = db().collection('usersData');

const rides = db().collection('rides')
const ridesData = db().collection('ridesData')
const meters = db().collection('meters')

const tolls = db().collection('tolls')
const packages = db().collection('package')

const registrations = db().collection('registrations')



/*****************************************/

export const refs = {
    users,
    rides,
    tolls,
    meters,
    packages,
    usersData,
    ridesData,
    registrations

};



// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";

// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries
// // Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyBh0WYH26yNFjI2wnP6G4QSELOXqdAK68M",
//   authDomain: "drivermanagment-b1f9f.firebaseapp.com",
//   projectId: "drivermanagment-b1f9f",
//   storageBucket: "drivermanagment-b1f9f.appspot.com",
//   messagingSenderId: "9753863073",
//   appId: "1:9753863073:web:e4104fe474d773fde121e0",
//   measurementId: "G-TG863Q9MTB"
// };
 
// // Initialize Firebase
// const app = initializeApp(firebaseConfig);

// // Initialize Firebase Authentication and get a reference to the service
// export const auth = getAuth(app);
// export default app;